import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { Validators, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { MatDatepicker, MatDialog, MatTabChangeEvent, MatDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PDFDocument, PDFPage, TextAlignment, layoutMultilineText, rgb } from 'pdf-lib';
import { finalize } from 'rxjs/operators';
import { DateFormatService } from 'src/app/Services/Utilities/date-format.service';
import { ExhibService } from 'src/app/Services/Utilities/exhib.service';
import { UserInfoService } from 'src/app/Services/Utilities/user-info.service';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-view-exhib',
  templateUrl: './view-exhib.component.html',
  styleUrls: ['./view-exhib.component.css']
})
export class ViewExhibComponent implements OnInit {

  todayDate = new Date();
  introFormGroup = this._formBuilder.group({
    Applicant: ['', Validators.required],
    School: ['', Validators.required],
    Email: ['', Validators.required],
    Phone: [''],
    TeamMembers: this._formBuilder.array([]),
    ProjectTitle: ['', Validators.required],
    Product: ['', Validators.required],
  });
  techFormGroup = this._formBuilder.group({
    ExecutiveSummary: ['', Validators.required],
    Goal: ['', Validators.required],
    TechnologyDriver: ['', Validators.required],
    ProblemStatement: ['', Validators.required],
    Description: ['', Validators.required],
    TRL: ['', Validators.required],
    Status: ['', Validators.required],
    Record: ['', Validators.required],
    IP: ['', Validators.required],
    Usefulness: ['', Validators.required],
    Benchmarking: ['', Validators.required],
    SDG: ['', Validators.required],
    MarketOpportunity: ['', Validators.required],
    BusinessModel: ['', Validators.required],
    MarketStrategy: ['', Validators.required],
    Category: ['', Validators.required],
  });
  attachmentFormGroup = this._formBuilder.group({
    Additional: [[]],
    YoutubeUrl: ['', Validators.required],
    ProductPic: ['', Validators.required],
    ProjectPoster: ['', Validators.required],
    Receipt:[[]]
  });

  teamMember={
    Name:'',
    IdentityNumber:'',
    USMStaff:false,
    Experience:'',
    Percentages: 0
  }

  publications={
    Name:''
  }
  intelliectuals={
    Name:''
  }

  researchs={
    Name:''
  }

  grants={
    Name:'',
    Value:0
  }

  consultations={
    Name:'',
    Value:0
  }

  technologys={
    Name:'',
    Value:0
  }

  product={
    Name:'',
    Value:0
  }

  industrialPatner={
    Name:'',
  }

  @ViewChild('picker', { read: MatDatepicker, static: false }) datePickerElement = MatDatepicker;

  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 5,
    allowSearchFilter: true,
  };

  email;
  uuid;
  edit = false;
  editID;

  Goals = [
    'GOAL 1: No Poverty',
    'GOAL 2: Zero Hunger',
    'GOAL 3: Good Health and Well-being',
    'GOAL 4: Quality Education',
    'GOAL 5: Gender Equality',
    'GOAL 6: Clean Water and Sanitation',
    'GOAL 7: Affordable and Clean Energy',
    'GOAL 8: Decent Work and Economic Growth',
    'GOAL 9: Industry, Innovation and Infrastructure',
    'GOAL 10: Reduced Inequality',
    'GOAL 11: Sustainable Cities and Communities',
    'GOAL 12: Responsible Consumption and Production',
    'GOAL 13: Climate Action',
    'GOAL 14: Life Below Water',
    'GOAL 15: Life on Land',
    'GOAL 16: Peace and Justice Strong Institutions',
    'GOAL 17: Partnerships to Achieve the Goal',
  ]

  Techs = [
    '5G/6G',
    'Sensor Technology',
    '4D/5D Printing	',
    'Advanced Materials',
    'Advanced Intelligent Systems',
    'Cybersecurity & Encryption',
    'Augmented Analytics & Data Discovery',
    'Blockchain',
    'Neurotechnology',
    'Bioscience Technology',
  ]

  Technologies = [
    'TRL 1 - Basic Principle',
    'TRL 2 - Formulation of Concept',
    'TRL 3 - Experimental Proof of Concept',
    'TRL 4 - Lab Validation',
    'TRL 5 - Validation in Real Environment',
    'TRL 6 - Demonstration in Real Environment',
    'TRL 7 - Demonstration in Prototype',
    'TRL 8 - Product Complete and Qualified',
    'TRL 9 - Product Proven',
  ]

  Market = [
    'Product Advertisement and Marketing',
    'Market Segment Penetration',
    'Product Development and Application Diversification',
    'Certification',
    'Geographical Expansion',
    'Strategic Alliance',
  ]

  Gap = [
    'Scalability',
    'Facilities/ machinery',
    'Certification',
    'Funding',
    'No industrial partner',
  ]

  Business = [
    'B2B',
    'B2C',

  ]

  TRLA = [
    'USM CIC Endorsement',
    'Industry Endorsement',
    'Self Assessment',
  ]
  role: string[];


  mark=[null,null,null,null,null]
  markMode = false;

  rubricType = null;


  calculatedMark = [null,null,null,null,null]

  getCalculatedMark(mark, percentage, index){

    if(mark > 0){
      let finalMark = ((percentage/100) * parseFloat(mark))/3 * 100
      this.calculatedMark[index] = parseFloat(finalMark.toFixed(2));
    }else if(mark == 0){
      this.calculatedMark[index] = 0;
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
    private toast: ToastrService,
    private dialog: MatDialog,
    private angularFireAuth: AngularFireAuth,
    private storage: AngularFireStorage,
    private firestore: AngularFirestore,
    private spinner: NgxSpinnerService,
    private router: Router,
    public exhibService: ExhibService,
    private userinfoSrv: UserInfoService,
  ) {

    this.userinfoSrv.currentRole.subscribe(role=>this.role = role);

    this.angularFireAuth.authState.subscribe(auth => {
      this.email = auth.email;
      this.uuid = auth.uid;

      if(exhibService.type === 'mark'){
        this.markMode = true;
        this.mark=[null,null,null,null,null]
        if(exhibService.exhib.individualMark){
          this.mark=exhibService.exhib.individualMark;
        }
        if(exhibService.exhib.ownCalculatedMark){
          this.calculatedMark=exhibService.exhib.ownCalculatedMark;
        }
      }else if(exhibService.type === 'disabled'){
        this.markMode = false;
        this.mark=exhibService.exhib.individualMark;
      }

      if (exhibService.exhib) {
        this.edit = true;
        let f = exhibService.exhib;
        this.editID = f.id;

        if(f.modeInfo)
          this.modeInfo = f.modeInfo;

        if(f.modeInfo){
          switch(f.modeInfo.typeOfParticipant){
            case 'University/College Student': this.rubricType = 1; break;
            case 'Primary/Secondary School Student': this.rubricType = 2; break;
            case 'Professional/Industry': this.rubricType = 3; break;
          }
        }

        this.introFormGroup = this._formBuilder.group({
          Applicant: [f.introFormGroup.Applicant, Validators.required],
          School: [f.introFormGroup.School, Validators.required],
          Email: [f.introFormGroup.Email, Validators.required],
          Phone: [f.introFormGroup.Phone],
          TeamMembers: this._formBuilder.array([]),
          ProjectTitle: [f.introFormGroup.ProjectTitle, Validators.required],
          Product: [f.introFormGroup.Product, Validators.required],
        });
        this.techFormGroup = this._formBuilder.group({
          ExecutiveSummary: [f.techFormGroup.ExecutiveSummary, Validators.required],
          Goal: [f.techFormGroup.Goal, Validators.required],
          TechnologyDriver: [f.techFormGroup.TechnologyDriver, Validators.required],
          ProblemStatement: [f.techFormGroup.ProblemStatement, Validators.required],
          Description: [f.techFormGroup.Description, Validators.required],
          TRL: [f.techFormGroup.TRL, Validators.required],
          Status: [f.techFormGroup.Status, Validators.required],
          Record: [f.techFormGroup.Record, Validators.required],
          IP: [f.techFormGroup.IP, Validators.required],
          Usefulness: [f.techFormGroup.Usefulness, Validators.required],
          Benchmarking: [f.techFormGroup.Benchmarking, Validators.required],
          SDG: [f.techFormGroup.SDG, Validators.required],
          MarketOpportunity: [f.techFormGroup.MarketOpportunity, Validators.required],
          BusinessModel: [f.techFormGroup.BusinessModel, Validators.required],
          MarketStrategy: [f.techFormGroup.MarketStrategy, Validators.required],
          Category: [f.techFormGroup.Category, Validators.required],
        });
        for (const dir of f.introFormGroup.TeamMembers) {
          this.teams().push(
            this._formBuilder.group({
              Name: [dir.Name, Validators.required],
              IdentityNumber: [dir.IdentityNumber, Validators.required],
              Experience: [dir.Experience, Validators.required],
              Percentages: [dir.Percentages, Validators.required],
              USMStaff: dir.USMStaff,
              isEdit: false
            }));
        }
       
        this.attachmentFormGroup = this._formBuilder.group({
          Additional: [f.attachmentFormGroup.Additional],
          YoutubeUrl: [f.attachmentFormGroup.YoutubeUrl, Validators.required],
          ProductPic: [f.attachmentFormGroup.ProductPic, Validators.required],
          ProjectPoster: [f.attachmentFormGroup.ProjectPoster, Validators.required],
          Receipt: [f.ReceiptUrls],
          ReceiptNames: [f.ReceiptNames],
        });


      } else {
        if(this.router.url.includes('view')){
          this.router.navigate(['/innovation'])
        }
        this.firestore.collection('Users').doc(this.uuid).get().forEach(file => {
          this.introFormGroup.get('Applicant').setValue(file.data().Name);
          this.introFormGroup.get('Email').setValue(file.data().Email);
          this.introFormGroup.get('Phone').setValue(file.data().TelephoneNo);
          this.introFormGroup.get('School').setValue(file.data().SchoolName);
        });
      }
      if (this.router.url.includes('edit')) {
        if (!this.edit)
          this.router.navigate(['/innovation'])
      }

    });

  }

  ngOnInit() {

  }

  modeInfo={
    category:'',
    usmStaff:'',
    mode:'',
    typeOfParticipant:''
  }

  validateError(formControl: FormControl) {

    if (formControl.value.split(' ').length > 150)
      formControl.setErrors({ 'invalid': true })
    else
      formControl.setErrors({ 'invalid': null })
  }


  back() {
    this.router.navigate(['/innovation']);

  }
  getWordLeft(word) {
    return word.split(' ');
  }


  selectedIndex = 0;
  async saveAndNext(ddd = false) {
    if (!ddd)
      this.selectedIndex++;

    if (!this.introFormGroup.invalid) {
      this.spinner.show();
      this.temporarySave();
    }

  }

  async temporarySave() {
    try {
      this.spinner.show();
      if (this.edit) {
        let five = this.attachmentFormGroup.getRawValue();
        await this.uploadImages(five);
        let info = {
          UpdatedDate: new Date(),
          UpdatedBy: this.email,
          CreatedBy: this.email,
          Status: this.exhibService.exhib? this.exhibService.exhib.Status:"Draft",
          introFormGroup: this.introFormGroup.value,
          techFormGroup: this.techFormGroup.value,
          UserID: this.uuid,
          attachmentFormGroup: five,
        }
        await this.firestore.collection("Exhib").doc(this.editID).update(info);
        this.spinner.hide();

      } else {
        await this.firestore.collection("ExhibID").doc("ID").get().forEach(async item => {
          let ID = ('000' + item.data().ID).slice(-3);
          ID = `EX${new Date().getFullYear()}-${ID}`;

          let five = this.attachmentFormGroup.getRawValue();
          await this.uploadImages(five);

          let info = {
            UpdatedDate: new Date(),
            CreatedDate: new Date(),
            UpdatedBy: this.email,
            CreatedBy: this.email,
            Status: this.exhibService.exhib? this.exhibService.exhib.Status:"Draft",
            introFormGroup: this.introFormGroup.value,
            techFormGroup: this.techFormGroup.value,
            UserID: this.uuid,
            attachmentFormGroup: five,
          }

          await this.firestore.collection("Exhib").doc(ID).set(info);
          await this.firestore.collection('ExhibID').doc("ID").set({ ID: item.data().ID + 1 })
          this.spinner.hide();
          this.edit = true;
          this.editID = ID;

        })
      }


    } catch (error) {
      console.log(error)

      this.toast.error(error, "Error happen");
      this.spinner.hide();

    }
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.selectedIndex = tabChangeEvent.index;
    this.saveAndNext(true);
  }

  teams(): FormArray {
    return this.introFormGroup.get('TeamMembers') as FormArray;
  }
  addTeams() {
    this.teams().push(this.newTeams());
  }

  newTeams() {
    let info = {...this.teamMember}
    this.teamMember={
      Name:'',
      IdentityNumber:'',
      USMStaff:false,
      Experience:'',
      Percentages: 0
    }
    return this._formBuilder.group({
      ...info,
      isEdit: false,
    });
  }

  validatePercentages = true;
  getTotalPercentage() {
    let share = this.teams().value;
    let total = 0;
    for (const e of share) {
      total += parseFloat(e.Percentages);
    }

    this.validatePercentages = (isNaN(total) ? 0 : total) <= 100;

    if (!this.validatePercentages)
      this.introFormGroup.setErrors({ invalid: true })
    else
      this.introFormGroup.setErrors(null)

    return isNaN(total) ? 0 : total;
  }



  save(event: any): void {
    let val = this.attachmentFormGroup.get('Additional').value;
    this.attachmentFormGroup.get('Additional').setValue([...val, ...event.target.files])
  }

  removeFile(index) {
    let val = this.attachmentFormGroup.get('Additional').value;
    val.splice(index, 1);
    this.attachmentFormGroup.get('Additional').setValue(val)
  }

  save4(event: any, value): void {
    this.attachmentFormGroup.get(value).setValue(event.target.files[0])
  }

  editForm(i, type) {
    switch (type) {
      case 'teams':
        this.teams().at(i).get('isEdit').setValue(!this.teams().at(i).get('isEdit').value);
        break;
    }
  }

  remove(i, type) {
    switch (type) {
      case 'teams':
        this.teams().removeAt(i);
        break;
    }
  }

  dateFormat = new DateFormatService();

  saveAsDraft() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.height = 'auto';
    dialogConfig.width = 'auto';

    const position = { top: '10%' };
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = 'Confirm save as draft';

    this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
      if (data) {
        try {
          this.spinner.show();

          if (this.edit) {
            let five = this.attachmentFormGroup.getRawValue();
            await this.uploadImages(five);

            let info = {
              UpdatedDate: new Date(),
              UpdatedBy: this.email,
              CreatedBy: this.email,
              Status: this.exhibService.exhib? this.exhibService.exhib.Status:"Draft",
              introFormGroup: this.introFormGroup.value,
              techFormGroup: this.techFormGroup.value,
              UserID: this.uuid,
              attachmentFormGroup: five,
            }
            await this.firestore.collection("Exhib").doc(this.editID).update(info);
            const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
            const infos = {
              message: "Draft has been saved by: " + this.email,
              date: new Date(),
              data: JSON.stringify(info),
            };
            await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
            await this.firestore.collection('ExhibLog').doc(dateFormat).collection('User').add(infos);
            this.spinner.hide();
            this.toast.success("Saved Successfully");
            this.router.navigate(['/innovation']);

          } else {
            await this.firestore.collection("ExhibID").doc("ID").get().forEach(async item => {
              let ID = ('000' + item.data().ID).slice(-3);
              ID = `EX${new Date().getFullYear()}-${ID}`;

              let five = this.attachmentFormGroup.getRawValue();
              await this.uploadImages(five);

              let info = {
                UpdatedDate: new Date(),
                CreatedDate: new Date(),
                UpdatedBy: this.email,
                CreatedBy: this.email,
                Status: this.exhibService.exhib? this.exhibService.exhib.Status:"Draft",
                introFormGroup: this.introFormGroup.value,
                techFormGroup: this.techFormGroup.value,
                UserID: this.uuid,
                attachmentFormGroup: five,
              }
              await this.firestore.collection("Exhib").doc(ID).set(info);
              const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
              const infos = {
                message: "Draft has been saved by: " + this.email,
                date: new Date(),
                data: JSON.stringify(info),
              };
              await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
              await this.firestore.collection('ExhibLog').doc(dateFormat).collection('User').add(infos);
              await this.firestore.collection('ExhibID').doc("ID").set({ ID: item.data().ID + 1 })

              this.spinner.hide();
              this.toast.success("Saved Successfully");
              this.router.navigate(['/innovation']);

            })
          }


        } catch (error) {
          console.log(error)
          this.toast.error(error, "Error happen");
          this.spinner.hide();

        }
      }
    })
  }

  saveAsSubmit() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.height = 'auto';
    dialogConfig.width = 'auto';

    const position = { top: '10%' };
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = 'Confirm submit the new application?';

    this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
      if (data) {
        try {
          this.spinner.show();
          if (this.edit) {

            let five = this.attachmentFormGroup.getRawValue();
            await this.uploadImages(five);
            let info = {
              UpdatedDate: new Date(),
              SubmittedDate: new Date(),
              CreatedBy: this.email,
              UpdatedBy: this.email,
              UserID: this.uuid,
              Status: "Submission in process",
              introFormGroup: this.introFormGroup.value,
              techFormGroup: this.techFormGroup.value,
              attachmentFormGroup: five,

            }
            await this.firestore.collection("Exhib").doc(this.editID).update(info);
            const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
            const infos = {
              message: "New application has been submitted by: " + this.email,
              date: new Date(),
              data: JSON.stringify(info),
            };
            await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
            await this.firestore.collection('ExhibLog').doc(dateFormat).collection('User').add(infos);
            this.spinner.hide();
            this.toast.success("Saved Successfully");
            this.router.navigate(['/innovation']);
          } else {
            await this.firestore.collection("ExhibID").doc("ID").get().forEach(async item => {
              let ID = ('000' + item.data().ID).slice(-3);
              ID = `EX${new Date().getFullYear()}-${ID}`;

              let five = this.attachmentFormGroup.getRawValue();
              await this.uploadImages(five);
              let info = {
                UpdatedDate: new Date(),
                SubmittedDate: new Date(),
                CreatedDate: new Date(),
                UpdatedBy: this.email,
                Status: "Submission in process",
                introFormGroup: this.introFormGroup.value,
                techFormGroup: this.techFormGroup.value,
                attachmentFormGroup: five,
                UserID: this.uuid,
                CreatedBy: this.email,
              }
              await this.firestore.collection("Exhib").doc(ID).set(info);

              const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
              const infos = {
                message: "New application has been submitted by: " + this.email,
                date: new Date(),
                data: JSON.stringify(info),
              };
              await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
              await this.firestore.collection('ExhibLog').doc(dateFormat).collection('User').add(infos);
              await this.firestore.collection('ExhibID').doc("ID").set({ ID: item.data().ID + 1 })

              this.spinner.hide();
              this.toast.success("Update Successfully");
              this.router.navigate(['/innovation']);
            })

          }


        } catch (error) {

          this.toast.error(error, "Error happen");
          this.spinner.hide();

        }
      }
    })
  }

  async uploadImages(five) {
    let realAttachments = [];
    for (const p of five.Additional) {
      if (p && p.name && !p.url) {
        realAttachments.push(await this.uploadImageAsPromise(p));
      } else if (p.url) {
        realAttachments.push(p);
      }
    }
    five.Additional = realAttachments;

    if (five.ProductPic && five.ProductPic.name && !five.ProductPic.url) {
      let file = await this.uploadImageAsPromise(five.ProductPic);
      five.ProductPic = null;
      five.ProductPic = file;
    }

    if (five.ProjectPoster && five.ProjectPoster.name && !five.ProjectPoster.url) {
      let file = await this.uploadImageAsPromise(five.ProjectPoster);
      five.ProjectPoster = null;
      five.ProjectPoster = file;
    }
  }


  uploadImageAsPromise(imageFile) {
    return new Promise((resolve, reject) => {
      const filePath = `Exhib/${imageFile.name}_${new Date().getTime()}`;
      var storageRef = this.storage.ref(filePath);
      const task = this.storage.upload(filePath, imageFile);
      let progress;
      task.snapshotChanges().pipe(
        finalize(() => {
          var downloadURL = storageRef.getDownloadURL();
          downloadURL.subscribe(async url => {
            let file = {
              name: imageFile.name,
              url: url,
            }
            resolve(file);
          });
        })
      ).subscribe(url => {
        if (url) {
          progress = url;
        }
      });
    });
  }

  async viewPPT(form) {
    if(form.url){
      const existingPdfBytes = await fetch(form.url).then(res => res.arrayBuffer())
      let file = new Blob([existingPdfBytes]);
      var fileURL = URL.createObjectURL(file);
      var anchor = document.createElement("a");
      anchor.download = form.name;
      anchor.href = fileURL;
      anchor.click();
    }else{
      let file = new Blob([form]);
      var fileURL = URL.createObjectURL(file);
      var anchor = document.createElement("a");
      anchor.download = form.name;
      anchor.href = fileURL;
      anchor.click();
    }
  }

  async viewPPT2(form, name) {
   
      const existingPdfBytes = await fetch(form).then(res => res.arrayBuffer())
      let file = new Blob([existingPdfBytes]);
      var fileURL = URL.createObjectURL(file);
      var anchor = document.createElement("a");
      anchor.download = name;
      anchor.href = fileURL;
      anchor.click();
  }

  SelectGoal(item) {
    this.techFormGroup.get('Goal').setValue(item);
  }

  SelectTech(item) {
    this.techFormGroup.get('TechnologyDriver').setValue(item);
  }

  SelectTechnology(item) {
    this.techFormGroup.get('TRL').setValue(item);
  }

  SelectTechnologyA(item) {
    this.techFormGroup.get('TRLAssessor').setValue(item);
  }

  SelectGap(item) {
    this.techFormGroup.get('Commercialization').setValue(item);
  }

  // async downloadSuSoTemplate() {
  //   const url = 'https://firebasestorage.googleapis.com/v0/b/cic-usm.appspot.com/o/CIC%20USM%20EXHIBITION%20TEMPLATE.pptx?alt=media&token=03193f46-8b87-4803-bc71-d6a34164b43a'
  //   const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
  //   let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
  //   var fileURL = URL.createObjectURL(file);
  //   var anchor = document.createElement("a");
  //   anchor.download = "Exhibition Pitch Deck CIC.ppt";
  //   anchor.href = fileURL;
  //   anchor.click();
  // }

  // async downloadModelCanvas() {
  //   const url = 'https://firebasestorage.googleapis.com/v0/b/cic-usm.appspot.com/o/business-model-canvas.docx?alt=media&token=1bbf176c-c0c6-49a0-ae03-11b432da3d9b'
  //   const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
  //   let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
  //   var fileURL = URL.createObjectURL(file);
  //   var anchor = document.createElement("a");
  //   anchor.download = "BusinessTemplate.docx";
  //   anchor.href = fileURL;
  //   anchor.click();
  // }

  // async preview(){
  //   this.spinner.show();

  //   let f1 = this.firstFormGroup.getRawValue();
  //   let f2 = this.secondFormGroup.getRawValue();
  //   let f3 = this.thirdFormGroup.getRawValue();
  //   let f4 = this.fourthFormGroup.getRawValue();
  //   let f5 = this.fifthFormGroup.getRawValue();

  //   this.pdfDoc = await PDFDocument.create();
  //   const font = await this.pdfDoc.embedFont(StandardFonts.TimesRoman)

  //   const fontBold = await this.pdfDoc.embedFont(StandardFonts.TimesRomanBold)

  //   this.currentPage = this.pdfDoc.addPage();
  //   this.currentY = 800;
  //   this.currentX = 50;
  //   this.currentFontSize = 18;
  //   this.autoText('Preview Technology Exhibition Submission', fontBold);
  //   this.currentY = this.currentY-10;

  //   this.currentFontSize = 16;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Introduction', fontBold);

  //   this.currentFontSize = 12;
  //   this.autoText('Applicant Name ', font);
  //   this.autoText(': '+f1.Applicant, font, true, this.currentY + this.currentFontSize + 4, true, 180, true);

  //   this.autoText('School', font);
  //   this.autoText(': '+f1.School, font, true, this.currentY + this.currentFontSize + 4, true, 180, true);

  //   this.autoText('Email', font);
  //   this.autoText(': '+f1.Email, font, true, this.currentY + this.currentFontSize + 4, true, 180, true);

  //   this.autoText('Phone number', font);
  //   this.autoText(': '+f1.Phone, font, true, this.currentY + this.currentFontSize + 4, true, 180, true);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Project Title: ', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f1.ProjectTitle, font);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Product/Technology Name: ', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f1.Product, font);


  //   if(f1.TeamMembers.length > 0){
  //     this.currentFontSize = 14;
  //     this.currentY = this.currentY-10;
  //     this.autoText('Team Members', fontBold);
  //   }

  //   let i = 1;
  //   for (const d of f1.TeamMembers) {
  //     this.currentFontSize = 12;
  //     this.autoText('(' + i + ')', font);
  //     this.autoText('Name', font, true, this.currentY + this.currentFontSize + 4, true, 70, true);
  //     this.autoText(': '+d.Name,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //     this.autoText('Identity Number ', font, false, this.currentY, true, 70, true);
  //     this.autoText(': '+d.IdentityNumber,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //     this.autoText('USM Staff ', font, false, this.currentY, true, 70, true);
  //     this.autoText(d.USMStaff?': Yes':': No',  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //     this.autoText('Expertise/Experience ', font, false, this.currentY, true, 70, true);
  //     this.autoText(': '+d.Experience,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //     this.autoText('Percentage(%)', font, false, this.currentY, true, 70, true);
  //     this.autoText(': '+d.Percentages,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);

  //     i++
  //   }

  //   if(f1.TeamMembers.length > 0){
  //     this.currentFontSize = 14;
  //     this.currentY = this.currentY-5;
  //     this.autoText(' Total Percentage: ' + this.getTotalPercentage(), font);
  //   }

  //   this.currentFontSize = 12;

  //   this.currentFontSize = 16;
  //   this.currentY = this.currentY-20;
  //   this.autoText('Technology Roadmap', fontBold);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Sustainable Development Goals: ', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f2.Goal, font);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('My STIE 10x10 Science & Technology Driver: ', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f2.TechnologyDriver, font);

  //   if(f2.Publication.length > 0){
  //     this.currentFontSize = 14;
  //     this.currentY = this.currentY-10;
  //     this.autoText('List of Publication', fontBold);
  //   }

  //   i = 1;
  //   for (const d of f2.Publication) {
  //     this.currentFontSize = 12;
  //     this.autoText('(' + i + ')', font);
  //     this.autoText('Name', font, true, this.currentY + this.currentFontSize + 4, true, 70, true);
  //     this.autoText(': ' +d.Name,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //     i++
  //   }

  //   if(f2.Intelliectual.length > 0){
  //     this.currentFontSize = 14;
  //     this.currentY = this.currentY-10;
  //     this.autoText('List of Intellectual Property', fontBold);
  //   }

  //   i = 1;
  //   for (const d of f2.Intelliectual) {
  //     this.currentFontSize = 12;
  //     this.autoText('(' + i + ')', font);
  //     this.autoText('Name', font, true, this.currentY + this.currentFontSize + 4, true, 70, true);
  //     this.autoText(': ' +d.Name,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //     i++
  //   }

  //   if(f2.Research.length > 0){
  //     this.currentFontSize = 14;
  //     this.currentY = this.currentY-10;
  //     this.autoText('List of Research Collaboration Agreement', fontBold);
  //   }

  //   i = 1;
  //   for (const d of f2.Research) {
  //     this.currentFontSize = 12;
  //     this.autoText('(' + i + ')', font);
  //     this.autoText('Name', font, true, this.currentY + this.currentFontSize + 4, true, 70, true);
  //     this.autoText(': ' +d.Name,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //     i++
  //   }

  //   if(f2.Grant.length > 0){
  //     this.currentFontSize = 14;
  //     this.currentY = this.currentY-10;
  //     this.autoText('List of Grants', fontBold);
  //   }

  //   i = 1;
  //   for (const d of f2.Grant) {
  //     this.currentFontSize = 12;
  //     this.autoText('(' + i + ')', font);
  //     this.autoText('Name', font, true, this.currentY + this.currentFontSize + 4, true, 70, true);
  //     this.autoText(': ' +d.Name,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //     this.autoText('Value (RM)', font, true, this.currentY , true, 70, true);
  //     this.autoText(': ' +d.Value,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //    i++
  //   }

  //   if(f2.Consultation.length > 0){
  //     this.currentFontSize = 14;
  //     this.currentY = this.currentY-10;
  //     this.autoText('List of Consultation', fontBold);
  //   }

  //   i = 1;
  //   for (const d of f2.Consultation) {
  //     this.currentFontSize = 12;
  //     this.autoText('(' + i + ')', font);
  //     this.autoText('Name', font, true, this.currentY + this.currentFontSize + 4, true, 70, true);
  //     this.autoText(': ' +d.Name,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //     this.autoText('Value (RM)', font, true, this.currentY , true, 70, true);
  //     this.autoText(': ' +d.Value,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //    i++
  //   }


  //   if(f2.Technology.length > 0){
  //     this.currentFontSize = 14;
  //     this.currentY = this.currentY-10;
  //     this.autoText('List of Technology Licencing', fontBold);
  //   }

  //   i = 1;
  //   for (const d of f2.Technology) {
  //     this.currentFontSize = 12;
  //     this.autoText('(' + i + ')', font);
  //     this.autoText('Name', font, true, this.currentY + this.currentFontSize + 4, true, 70, true);
  //     this.autoText(': ' +d.Name,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //     this.autoText('Value (RM)', font, true, this.currentY, true, 70, true);
  //     this.autoText(': ' +d.Value || 0,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //    i++
  //   }

  //   if(f2.Products.length > 0){
  //     this.currentFontSize = 14;
  //     this.currentY = this.currentY-10;
  //     this.autoText('List of Product Commercialization', fontBold);
  //   }

  //   i = 1;
  //   for (const d of f2.Products) {
  //     this.currentFontSize = 12;
  //     this.autoText('(' + i + ')', font);
  //     this.autoText('Name', font, true, this.currentY + this.currentFontSize + 4, true, 70, true);
  //     this.autoText(': ' +d.Name,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //     this.autoText('Value (RM)', font, true, this.currentY , true, 70, true);
  //     this.autoText(': ' +d.Value || 0,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //    i++
  //   }

  //   if(f2.IndustrialPatners.length > 0){
  //     this.currentFontSize = 14;
  //     this.currentY = this.currentY-10;
  //     this.autoText('List of Industrial Partners/Collaborators', fontBold);
  //   }

  //   i = 1;
  //   for (const d of f2.IndustrialPatners) {
  //     this.currentFontSize = 12;
  //     this.autoText('(' + i + ')', font);
  //     this.autoText('Name', font, true, this.currentY + this.currentFontSize + 4, true, 70, true);
  //     this.autoText(': ' +d.Name,  font, true, this.currentY + this.currentFontSize + 4, true, 180, true);
  //    i++
  //   }

  //   this.currentFontSize = 16;
  //   this.currentY = this.currentY-20;
  //   this.autoText('Technology Description', fontBold);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Executive Summary', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f3.ExecutiveSummary, font);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Problem Statement', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f3.ProblemStatement, font);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Technology Readiness Level (TRL)', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f3.TRL, font);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('TRL Assessor', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f3.TRLAssessor, font);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Product/Technology Status', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f3.Status, font);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Usefulness and Application ', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f3.Usefulness, font);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Technology Benchmarking', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f3.Benchmarking, font);


  //   this.currentFontSize = 16;
  //   this.currentY = this.currentY-20;
  //   this.autoText('Technology Commercialization', fontBold);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Target Market ', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f4.TargetMarket, font);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Go-to-market Strategy ', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f4.MarketStrategy, font);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Market Strategy Type  ', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f4.MarketStrategyType.join(','), font);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Business Model ', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f4.BusinessModel, font);

  //   this.currentFontSize = 14;
  //   this.currentY = this.currentY-10;
  //   this.autoText('Commercialization Gap ', font);
  //   this.currentFontSize = 12;
  //   this.autoText(f4.Commercialization, font);



  //   const pdfBytes = await this.pdfDoc.save()
  //   let f = new Blob([pdfBytes], { type: 'application/pdf' });
  //   var fileURL = URL.createObjectURL(f);
  //   var anchor = document.createElement("a");
  //   anchor.download =  "exhibPreview.pdf";
  //   anchor.href = fileURL;
  //   anchor.click();
  //   this.spinner.hide();
  // }


  pdfDoc: PDFDocument;
  currentX = 0;
  currentY = 0;
  currentPage: PDFPage;
  currentFontSize = 12

  async autoText(text, font, fixedYPosition = false, y = 0, fixedXPosition = false, x = 0 , correctWidth = false) {
    let multiText = layoutMultilineText(text,
      {
        alignment: TextAlignment.Left,
        fontSize: this.currentFontSize,
        font: font,
        bounds: { x: this.currentX, y: this.currentY - this.currentFontSize - 5, width: correctWidth?350: 500, height: 600 }
      })

      if(fixedYPosition)
        this.currentY = y;

      for (let i = 0; i < multiText.lines.length; i++) {
      this.currentPage.drawText(`${multiText.lines[i].text}`, {
        x: fixedXPosition?x: this.currentX,
        y: this.currentY,
        size: this.currentFontSize,
        font: font,
        color: rgb(0, 0, 0)
      })

      if (this.currentY < 80) {
        this.currentPage = this.pdfDoc.addPage();
        this.currentY = 780
      }
      this.currentY = this.currentY - this.currentFontSize - 4;

    }

  }

  submitMark(){
    if(this.rubricType == 2){
      this.mark = this.mark.slice(0, 4)
      this.calculatedMark = this.calculatedMark.slice(0,4)
    }
    if(this.mark.some(e=> e == null || e == '')){
        this.toast.warning('Havent fill in the score for all form')
        return;
    }
    console.log(this.calculatedMark)
    console.log(this.exhibService.exhib.calculatedMark)

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.height = 'auto';
    dialogConfig.width = '30%';

    const position = { top: '15%' };
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = 'Confirm submit this score? Total : ' + this.calculatedMark.reduce((a,b)=> a+ b ,0);

    this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
      if (data) {
        try {
          this.spinner.show();
          const marks = {
            ...this.exhibService.exhib.marks,
            [this.email]: this.mark
          }

          const calculatedMark = {
            ...this.exhibService.exhib.calculatedMark,
            [this.email]: this.calculatedMark
          }

          await this.firestore.collection("Exhib").doc(this.exhibService.exhib.id).update({ Status: "Assigned", marks: marks, calculatedMark: calculatedMark, UpdatedDate: new Date(), UpdatedBy: this.email });


          const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
          const info = {
            message: "Application " + this.exhibService.exhib.id.id + " has been marked by Email: " + this.email,
            date: new Date()
          };
          await this.firestore.collection('ExhibLog').doc(dateFormat).set({ Date: new Date() });
          await this.firestore.collection('ExhibLog').doc(dateFormat).collection('Admin').add(info);
          this.spinner.hide();
          this.toast.success("Mark Successfully");
          // this.router.navigate(['/innovation'])
        } catch (error) {
          this.toast.error(error, "Error happen");
          this.spinner.hide();

        }
      }
      })
    
  }






}
